<div class="document-pagination">
  <span (click)="updatePagination(currentPage - 1)" [hidden]="currentPage === 1" class="icon-i-chevron-left"></span>
  <div *ngFor="let page of pagesSelectionOptions">
    <span [class.active]="page + 1 === currentPage" (click)="updatePagination(page + 1)">{{ page + 1 }}</span>
    <ng-container *ngIf="pages > 7 && page + 1 === 3">
      <span class="dots">. . .</span>
      <ng-container *ngIf="currentPage > 3 && currentPage <= pages - 3">
        <span class="dots active">{{ currentPage }}</span>
        <span class="dots">. . .</span>
      </ng-container>
    </ng-container>
  </div>
  <span (click)="updatePagination(currentPage + 1)" [hidden]="currentPage === pages" class="icon-i-chevron-right"></span>
</div>
